import { Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TemaEvaluacion = () => {    
    const { promptData, setPromptData} = useActividadesContext();

    const handleIndicationsProyectChange = (event) => {
        const { value } = event.target;        
        setPromptData((prevData) => ({
            ...prevData,
            tema_evaluacion: value 
          }));
      };
    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} > Tema de la evaluación *</Typography>
            <TextField
                required
                id="tema"
                placeholder='Escribe el tema de la evaluación aquí. Ejemplo: Comida saludable'
                name="temma"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.tema_evaluacion}
                onChange={handleIndicationsProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default TemaEvaluacion;




